// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navlinks-module--navigation--2630R"};